module.exports = __webpack_public_path__ + "static/media/TitilliumWeb-Light.edc21ba4.ttf";